import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-rewardscard',
  templateUrl: './rewardscard.component.html',
  styleUrls: ['./rewardscard.component.scss']
})
export class RewardscardComponent implements OnInit {

  private card_id: number = 0;
  public catLogData = [];
  public isChecked: string = "";
  public isModalOpen: boolean = false;
  public isDisclaimerOpen : boolean = false;
  public isOtpShow: boolean = false;
  private email: string = '';
  private otp: string = '';
  public emailError: string = '';
  private userId: string = '';
  private returnedUserId: string = '';
  public disclaimerText:string = '';

  constructor(
    private activatedRoute: ActivatedRoute, 
    private apiService: ApiService,
    private router:Router
  ) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      this.card_id = parseInt(params.get('id'));
      this.getDataForCard();
    });
  }

  getDataForCard():void{
    let url = "tango/get-catalog"
    this.apiService.getuserData(url).subscribe((res: any) => {
      this.catLogData = res?.brands;
    })
  }

  clickOnCard(brand):void {
    this.isChecked = brand;
  }

  clickOnOrder(brand, utid):void {
    this.userId = utid;
    if (this.isChecked == brand) {
      this.isModalOpen = true;
    }
  }

  clickOnDisclaimer(str):void{
    this.disclaimerText = str;
    this.isDisclaimerOpen = true;
  }

  closeDisclaimer():void{
    this.disclaimerText = '';
    this.isDisclaimerOpen = false;
  }

  closeModal():void{
    this.isModalOpen = false;
  }

  cancelModal():void{
    this.isOtpShow = false;
  }

  submitEmail():void{
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.email) {
      this.isOtpShow = false;
      this.emailError = 'Email is required.';
    } else if (!emailPattern.test(this.email)) {
      this.isOtpShow = false;
      this.emailError = 'Please enter a valid email address.';
    } else {
      this.emailError = '';
      this.sendEmailInApi();
    }
  }

  onEmailInput(event: Event):void {
    this.email = (event.target as HTMLInputElement).value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.email) {
      this.emailError = 'Email is required.';
    } else if (!emailPattern.test(this.email)) {
      this.emailError = 'Please enter a valid email address.';
    } else {
      this.emailError = '';
    }
  }

  onOtpInput(event: Event):void{
    this.otp = (event.target as HTMLInputElement).value;
  }

  sendEmailInApi():void{
    let obj = {
      "userId": this.userId,
      "email": this.email
    };
    let url = "tango/send-otp"
    this.apiService.postuserData(url, obj).subscribe((res: any) => {
      if (res['status'] == "success") {
        this.isOtpShow = true;
        this.returnedUserId = res.data.userId;
      }else{
        this.emailError = res['message'];
        this.isOtpShow = false;
      }
    })
  }

  varifyOtp():void{
    let obj = {
      "userId":this.returnedUserId,
      "otp":this.otp,
      "amount":this.card_id,
      "utid":this.userId
    }
    let url = "tango/verify-otp"
    this.apiService.postuserData(url, obj).subscribe((res: any) => {
      if (res['success']) {
        this.router.navigate(['/rewards-confirmation']);
      }
    })
  }

}
